import React from 'react';
import './Loading.css'; // For styling
  import { useTranslation } from 'react-i18next';

const Loading = () => {
       const { t, i18n } = useTranslation();
        
            const changeLanguage = (e) => {
              i18n.changeLanguage(e.target.value);
          };
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>{t('chargement')}</p>
    </div>
  );
};

export default Loading;